module.exports = __webpack_public_path__ + "static/media/Museo-Thyssen-Bornemisza.5b8d5d70.jpg";